import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/Blog.css';

const BlogCategories = () => {
  const cats = ['Electrical Tips','Solar Energy','Security','Safety','Technology','Guides','Networking'];
  return (
    <div className="blog-page">
      <h1>Blog Categories</h1>
      <p>Manage blog categories.</p>
      <button className="add-btn"><FaPlus /> Add Category</button>
      <table className="blog-table">
        <thead><tr><th>#</th><th>Category</th><th>Posts</th><th>Actions</th></tr></thead>
        <tbody>{cats.map((c,i)=>(<tr key={i}><td>{i+1}</td><td>{c}</td><td>{Math.floor(Math.random()*3)+1}</td><td><button className="edit-btn">Edit</button> <button className="delete-btn">Delete</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default BlogCategories;
